/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useStyles } from '~src/hooks/useStyles';
import { styleFn } from './style';
import { Button, Input } from 'antd';
import { useIntl } from 'react-intl';
import { UploadFilesDropArea } from '../UploadDropZonePannel/UploadFilesDropArea';
import { Fragment, ReactNode, useEffect, useState } from 'react';

const { TextArea } = Input;

export type AnswerFormValues = {
  title?: string;
  description?: string;
  answer: string | undefined;
};

export const defaultAnswerFormValues: AnswerFormValues = {
  title: '',
  description: '',
  answer: '',
};

type AnswerFormProps = {
  formValues: AnswerFormValues;
  handleValueChange: (key: keyof AnswerFormValues, newValue: unknown) => void;
  withUploadFiles?: boolean;
  titleLabel?: ReactNode;
  descriptionLabel?: ReactNode;
  resetEnabled?: boolean;
};

const AnswerForm: React.FC<AnswerFormProps> = (props) => {
  const {
    formValues,
    handleValueChange,
    titleLabel,
    descriptionLabel,
    withUploadFiles = true,
    resetEnabled = false,
  } = props;

  const intl = useIntl();
  const styles = useStyles(styleFn);

  return (
    <div
      css={styles.formContainer}
      style={{
        // backgroundColor: 'red',
        width: '100%',
        padding: 0,
        margin: '0',
      }}>
      <div css={styles.formItem}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 10,
          }}>
          <span
            css={styles.formLabel}
            style={{ fontWeight: 'bold', fontSize: '15px' }}>
            {descriptionLabel || intl.formatMessage({ id: 'ask-question' })}
          </span>
          {resetEnabled && (
            <Button type={'dashed'}>
              {intl.formatMessage({ id: 'reset' })}
            </Button>
          )}
        </div>
        <TextArea
          placeholder={intl.formatMessage({ id: 'answer-question' })}
          value={formValues.answer}
          onChange={(e) => handleValueChange('answer', e.target.value)}
          maxLength={10000}
          style={{ height: 80 }}
        />
      </div>
      {withUploadFiles && (
        <Fragment>
          <p css={styles.formLabel}>
            {intl.formatMessage({ id: 'type-files' })}
          </p>
          <UploadFilesDropArea />
        </Fragment>
      )}
    </div>
  );
};

export default AnswerForm;
